export enum ProblemTypes {
  Classification = 'classification',
  Regression = 'regression'
}
